import { formatMoney, LoanCriteria } from '@nemuru-eng/js-api-client';

import { LoanStatusTag } from '@/components/shared/components/LoanStatusTag/LoanStatusTag';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const statusWithPrincipalAmountMobile = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.5,
    field: 'status',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData: { row: LoanCriteria }) => {
      return (
        <div style={{ minWidth: '120px' }}>
          <div style={{ minWidth: '120px' }}>
            <LoanStatusTag status={rowData.row.status} />
          </div>
          <div style={{ color: palette.text.secondary }}>
            <strong>{formatMoney(amountToValueMoneyMapper(rowData.row.loanConditions.principal))}</strong>
          </div>
        </div>
      );
    },
  };
};
